import { Investment, Building, Floors, Floor } from 'browser/schemes';

// Building imports
import map1 from './maps/3d/map1';

import map1A from './maps/3d/map1A';
import map2A from './maps/3d/map2A';
import map3A from './maps/3d/map3A';

import map1B from './maps/3d/map1B';
import map2B from './maps/3d/map2B';
import map3B from './maps/3d/map3B';

import estateMap from './maps/3d/estateMap';

import { ReactComponent as b2 } from './maps/floors/b-2.inline.svg';
import { ReactComponent as b1 } from './maps/floors/b-1.inline.svg';

import { ReactComponent as pM2 } from './maps/floors/p-2.svg';
import { ReactComponent as pM1 } from './maps/floors/p-1.svg';
import { ReactComponent as p0 } from './maps/floors/p0.svg';
import { ReactComponent as p1 } from './maps/floors/p1.svg';
import { ReactComponent as p2 } from './maps/floors/p2.svg';
import { ReactComponent as p3 } from './maps/floors/p3.svg';
import { ReactComponent as p4 } from './maps/floors/p4.svg';
import { ReactComponent as p5 } from './maps/floors/p5.svg';
import { ReactComponent as p6 } from './maps/floors/p6.svg';
import { ReactComponent as p7 } from './maps/floors/p7.svg';

import { ReactComponent as pA0 } from './maps/floors/pA0.svg';
import { ReactComponent as pA1 } from './maps/floors/pA1.svg';
import { ReactComponent as pA2 } from './maps/floors/pA2.svg';
import { ReactComponent as pA3 } from './maps/floors/pA3.svg';
import { ReactComponent as pA4 } from './maps/floors/pA4.svg';
import { ReactComponent as pA5 } from './maps/floors/pA5.svg';
import { ReactComponent as pA6 } from './maps/floors/pA6.svg';
import { ReactComponent as pA7 } from './maps/floors/pA7.svg';

import { ReactComponent as pB0 } from './maps/floors/pB0.svg';
import { ReactComponent as pB1 } from './maps/floors/pB1.svg';
import { ReactComponent as pB2 } from './maps/floors/pB2.svg';
import { ReactComponent as pB3 } from './maps/floors/pB3.svg';
import { ReactComponent as pB4 } from './maps/floors/pB4.svg';
import { ReactComponent as pB5 } from './maps/floors/pB5.svg';
import { ReactComponent as pB6 } from './maps/floors/pB6.svg';
import { ReactComponent as pB7 } from './maps/floors/pB7.svg';

import qualityBreakpoint1A1 from './assets/stopklatka-1.jpg';
import qualityBreakpoint2A1 from './assets/stopklatka-2.jpg';
import qualityBreakpoint3A1 from './assets/stopklatka-3.jpg';

import qualityBreakpoint1B1 from './assets/stopklatka-7.jpg';
import qualityBreakpoint2B1 from './assets/stopklatka-26.jpg';
import qualityBreakpoint3B1 from './assets/stopklatka-39.jpg';

const floorsA = new Floors({
  streets: {
    top: '',
    bottom: '',
    left: '',
    right: '',
  },
  windroseRotation: 150,
  list: [
    new Floor({
      map: b2,
      level: -2,
      backgroundImage: require(`./assets/floors/b-2.png`),
    }),
    new Floor({
      map: b1,
      level: -1,
      backgroundImage: require(`./assets/floors/b-1.png`),
    }),
    new Floor({
      map: pA0,
      level: 0,
      backgroundImage: require(`./assets/floors/pA0.png`),
    }),
    new Floor({
      map: pA1,
      level: 1,
      backgroundImage: require(`./assets/floors/pA1.png`),
    }),
    new Floor({
      map: pA2,
      level: 2,
      backgroundImage: require(`./assets/floors/pA2.png`),
    }),
    new Floor({
      map: pA3,
      level: 3,
      backgroundImage: require(`./assets/floors/pA3.png`),
    }),
    new Floor({
      map: pA4,
      level: 4,
      backgroundImage: require(`./assets/floors/pA4.png`),
    }),
    new Floor({
      map: pA5,
      level: 5,
      backgroundImage: require(`./assets/floors/pA5.png`),
    }),
    new Floor({
      map: pA6,
      level: 6,
      backgroundImage: require(`./assets/floors/pA6.png`),
    }),
    new Floor({
      map: pA7,
      level: 7,
      backgroundImage: require(`./assets/floors/pA7.png`),
    }),
  ],
});

const floorsB = new Floors({
  streets: {
    top: '',
    bottom: '',
    left: '',
    right: '',
  },
  windroseRotation: 145,
  list: [
    new Floor({
      map: b2,
      level: -2,
      backgroundImage: require(`./assets/floors/b-2.png`),
    }),
    new Floor({
      map: b1,
      level: -1,
      backgroundImage: require(`./assets/floors/b-1.png`),
    }),
    new Floor({
      map: pB0,
      level: 0,
      backgroundImage: require(`./assets/floors/pB0.png`),
    }),
    new Floor({
      map: pB1,
      level: 1,
      backgroundImage: require(`./assets/floors/pB1.png`),
    }),
    new Floor({
      map: pB2,
      level: 2,
      backgroundImage: require(`./assets/floors/pB2.png`),
    }),
    new Floor({
      map: pB3,
      level: 3,
      backgroundImage: require(`./assets/floors/pB3.png`),
    }),
    new Floor({
      map: pB4,
      level: 4,
      backgroundImage: require(`./assets/floors/pB4.png`),
    }),
    new Floor({
      map: pB5,
      level: 5,
      backgroundImage: require(`./assets/floors/pB5.png`),
    }),
    new Floor({
      map: pB6,
      level: 6,
      backgroundImage: require(`./assets/floors/pB6.png`),
    }),
    new Floor({
      map: pB7,
      level: 7,
      backgroundImage: require(`./assets/floors/pB7.png`),
    }),
  ],
});

const floorsE = new Floors({
  streets: {
    top: '',
    bottom: '',
    left: '',
    right: '',
  },
  windroseRotation: 150,
  list: [
    new Floor({
      map: pM2,
      level: -2,
      backgroundImage: require(`./assets/floors/p-2.png`),
    }),
    new Floor({
      map: pM1,
      level: -1,
      backgroundImage: require(`./assets/floors/p-1.png`),
    }),
    new Floor({
      map: p0,
      level: 0,
      backgroundImage: require(`./assets/floors/p0.png`),
    }),
    new Floor({
      map: p1,
      level: 1,
      backgroundImage: require(`./assets/floors/p2.png`),
    }),
    new Floor({
      map: p2,
      level: 2,
      backgroundImage: require(`./assets/floors/p2.png`),
    }),
    new Floor({
      map: p3,
      level: 3,
      backgroundImage: require(`./assets/floors/p3.png`),
    }),
    new Floor({
      map: p4,
      level: 4,
      backgroundImage: require(`./assets/floors/p4.png`),
    }),
    new Floor({
      map: p5,
      level: 5,
      backgroundImage: require(`./assets/floors/p5.png`),
    }),
    new Floor({
      map: p6,
      level: 6,
      backgroundImage: require(`./assets/floors/p6.png`),
    }),
    new Floor({
      map: p7,
      level: 7,
      backgroundImage: require(`./assets/floors/p7.png`),
    }),
  ],
});

const buildingA = new Building({
  name: 'A',
  active: true,
  spritespin: {
    framesURL: {
      day: require('./assets/sprite.webp'),
    },
    framesPerRow: 10,
    frames: 44,
    breakpoints: [7, 30, 0],
    qualityBreakpoints: [
      qualityBreakpoint2A1,
      qualityBreakpoint3A1,
      qualityBreakpoint1A1,
    ],
    maps: [map2A, map3A, map1A],
    windroseInitialRotation: 235,
    reverse: true,
    frameTime: 50,
  },
  floors: floorsA,
});

const buildingB = new Building({
  name: 'B',
  active: true,
  spritespin: {
    framesURL: {
      day: require('./assets/sprite2.webp'),
    },
    framesPerRow: 10,
    frames: 40,
    breakpoints: [7, 26, 39],
    qualityBreakpoints: [
      qualityBreakpoint1B1,
      qualityBreakpoint2B1,
      qualityBreakpoint3B1,
    ],
    maps: [map1B, map2B, map3B],
    windroseInitialRotation: 230,
    reverse: true,
    frameTime: 50,
  },
  floors: floorsB,
});

const buildingE = new Building({
  name: 'E',
  active: true,
  spritespin: {
    framesURL: {
      day: require('./assets/background.jpg'),
    },
    framesPerRow: 1,
    frames: 1,
    breakpoints: [0],
    maps: [map1],
    windroseInitialRotation: 150,
    reverse: true,
    frameTime: 50,
  },
  floors: floorsE,
});

const buildings = new Map();
buildings.set(buildingA.id, buildingA);
buildings.set(buildingB.id, buildingB);
buildings.set(buildingE.id, buildingE);

const investment = new Investment({
  investmentName: 'Wyspa Solna',
  flatsURL:
    'https://crm.vacationinvestments.pl/sendData.php',
  buildings,
  buildingsMap: estateMap,
  buildingsBackground: require('./assets/estate.jpg'),
});

export default investment;
